import { render } from "./App.vue?vue&type=template&id=4b7a1703&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4b7a1703&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=4b7a1703&lang=scss"
import "./App.vue?vue&type=style&index=2&id=4b7a1703&lang=css"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7a1703"]])

export default __exports__